import React, { useState, useCallback } from 'react';

import { Contact, contactFactory } from '@/types/contact';
import { useAppSelector } from '@/store';
import { authStore } from '@/store/auth';
import { billingContactsApi } from '@/services/api';
import { BillingContactForm } from '@/components/pages/Subscription/Presentation/Form/Address/BillingContactForm';
import { useApiErrorHandler } from '@/hooks/useApiErrorHandler';

type Props = {
  setFieldValue: {
    (
      field:
        | 'billingContactId'
        | 'contactId'
        | 'serviceIds'
        | 'adminIds'
        | 'users'
        | 'startsOn'
        | 'projectClassId',
      value: any,
      shouldValidate?: boolean | undefined,
    ): void;
    (field: string, value: any): void;
  };
  onComplete: () => void;
};

export const BillingContactFormCreateContainer: React.FC<Props> = ({
  setFieldValue,
  onComplete,
}) => {
  const { apiErrorHandler } = useApiErrorHandler();
  const organizationId = useAppSelector(
    authStore.selectors.organizationIdSelector,
  );
  const [contact] = useState<Contact>(() => contactFactory());

  const [isConnecting, setIsConnecting] = useState(false);

  const onSubmit = useCallback(
    async (contact: Contact) => {
      try {
        setIsConnecting(true);

        const item = await billingContactsApi.create({
          data: {
            contact,
            organizationId,
          },
        });

        setFieldValue('billingContactId', item.id);

        onComplete();
        setIsConnecting(false);
      } catch (err) {
        setIsConnecting(false);
        apiErrorHandler(err);
      }
    },
    [apiErrorHandler, onComplete, organizationId, setFieldValue],
  );

  const childProps = { contact, isConnecting, onSubmit };
  return <BillingContactForm {...childProps} />;
};
